import { combineReducers } from "redux";
import { user } from "./user";
import { timestamp } from "./timestamp";
import { dailytexts } from "./dailytexts";
import { default as tutorial } from "./tutorial/reducer";

export default combineReducers({
  user,
  timestamp,
  dailytexts,
  tutorial
});



// WEBPACK FOOTER //
// ./src/store/reducers.js